/**
 * Annotation time extension handler.
 *
 * This module type is configuration-only and does not create annotation rows.
 */
import { BaseExtensionHandler } from "../_base.ts"
import type { ExtensionManifest, SerializedAnnotation, StoredAnnotation } from "../_interface.ts"
import { annotationTimeConfigSchema, createAnnotationTimeSchema, updateAnnotationTimeSchema } from "./schema.ts"

export class AnnotationTimeHandler extends BaseExtensionHandler {
  readonly type = "annotation_time"
  readonly manifest: ExtensionManifest = {
    type: "annotation_time",
    label: "Annotation Time",
    scope: "case",
    storage: "structured",
    supportsLinking: false
  }

  getConfigSchema() {
    return annotationTimeConfigSchema
  }

  getCreateSchema() {
    return createAnnotationTimeSchema
  }

  getUpdateSchema() {
    return updateAnnotationTimeSchema
  }

  serializeForDb(_apiData: unknown): SerializedAnnotation {
    return {
      annotation: {},
      data: [],
      files: []
    }
  }

  deserializeFromDb(stored: StoredAnnotation): unknown {
    return {
      id: stored.annotation.id,
      submission_id: stored.annotation.submission_id,
      project_module_id: stored.annotation.project_module_id,
      created_at: stored.annotation.created_at,
      updated_at: stored.annotation.updated_at
    }
  }

  getExportColumns(_templateSchema: unknown): string[] {
    return []
  }

  toExportRow(_annotations: StoredAnnotation[], _templateSchema: unknown): Record<string, string | number> {
    return {}
  }
}
